import React from "react";
import { Typography } from "antd";

interface CandidatesPageHeaderProps {}

const CandidatesPageHeader: React.FC<CandidatesPageHeaderProps> = () => {
  return (
    <div className="dashboard-page-title">
      <Typography.Title level={4} style={{ margin: 0 }}>
        Talent Pool
      </Typography.Title>
    </div>
  );
};

export default CandidatesPageHeader;
